import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Toolbar from "@mui/material/Toolbar";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import UploadFile from "@mui/icons-material/UploadFile";
import FileOpen from "@mui/icons-material/FileOpen";
import Cabin from "@mui/icons-material/Cabin";
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/facilitr_logo.png";

const Links = [
  { path: "/my-facilities", label: "My Facilities", icon: Cabin },
  { path: "/my-documents", label: "My Documents", icon: FileOpen },
  { path: "/upload-document", label: "Upload Document", icon: UploadFile },
];

const Actions = Links.map((link, key) => {
  return (
    <ListItem disablePadding key={link.label}>
      <ListItemButton component={Link} to={link.path}>
        <ListItemIcon>{React.createElement(link.icon)}</ListItemIcon>
        <ListItemText primary={link.label} />
      </ListItemButton>
    </ListItem>
  );
});

const drawerWidth = "20%";

const Sidebar = () => {
  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: "12%",
          maxWidth: "240px",
          boxSizing: "border-box",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar />
      {/* <img src={logo} className="App-logo" alt="logo" /> */}

      <List>{Actions}</List>
    </Drawer>
  );
};

export default Sidebar;
